export const GET_EMPLOYEES = 'GET_EMPLOYEES';
export const SET_EMPLOYEES_PAGINATION = 'SET_EMPLOYEES_PAGINATION';
export const SET_EMPLOYEES_FILTERS = 'SET_EMPLOYEES_FILTERS';
export const RESET_EMPLOYEES = 'RESET_EMPLOYEES';
export const TOGGLE_EMPLOYEE = 'TOGGLE_EMPLOYEE';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const GET_EMPLOYEE_BY_ID = 'GET_EMPLOYEE_BY_ID';
export const RESET_EMPLOYEE_FORM = 'RESET_EMPLOYEE_FORM';
export const MODIFY_EDITING_EMPLOYEE = 'MODIFY_EDITING_EMPLOYEE';
export const EMPLOYEES_SET_FILE = 'EMPLOYEES_SET_FILE';
export const EMPLOYEE_UPLOAD_FILE = 'EMPLOYEE_UPLOAD_FILE';
export const EMPLOYEE_PROGRESS_FILE = 'EMPLOYEE_PROGRESS_FILE';
export const GET_EMPLOYEE_REPORT_CSV = 'GET_EMPLOYEE_REPORT_CSV';

export const GET_CUSTOM_FIELDS_EMPLOYEES = 'GET_CUSTOM_FIELDS_EMPLOYEES';
export const MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE = 'MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/constants/employees_constants.js